import { Hero } from '../components/Hero';

const clauses = [
  {
    title: 'Eigen risico',
    body:
      'Deelname aan onze activiteiten is op eigen risico. Bij een ongeval zullen wij ons best doen om juist te handelen, maar wij zijn geen hulpverleners. Restart is niet aansprakelijk voor verlies of schade.',
  },
  {
    title: 'Privacy',
    body:
      "Er kunnen foto's gemaakt worden voor de Instagram. Wij proberen zoveel mogelijk kinderen niet met hun gezicht op de foto te zetten. De foto's op de website zijn in overleg met ouders gebruikt.",
  },
];

export const AlgemeneVoorwaarden = () => {
  return (
    <>
      <Hero
        title="Algemene voorwaarden"
        description="Bekijk hier de voorwaarden van Restart."
        imageSrc="/images/hero-privacy.jpg"
        overlay
        fullHeight={false}
        eyebrow="Beleid"
      />

      <section className="py-28 md:py-36 px-6 sm:px-10 md:px-16 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20">
            <div className="md:col-span-4">
              <div className="md:sticky md:top-28 flex flex-col gap-3">
                <span className="text-[#0D0A00]/40 font-mono text-[12px] tracking-wider uppercase">
                  Laatst bijgewerkt
                </span>
                <span className="text-[#0D0A00] text-[17px] font-medium">06 mei 2025</span>
                <span className="mt-6 eyebrow text-[#0D0A00]/55">Algemene voorwaarden</span>
              </div>
            </div>

            <div className="md:col-span-8">
              <h1 className="text-[#0D0A00] text-[44px] md:text-[60px] font-medium tracking-[-0.035em] leading-[1.02] mb-16">
                Het kleine{' '}
                <span className="font-serif-display italic font-normal text-[#0D0A00]/70">leesvoer.</span>
              </h1>

              <div className="flex flex-col divide-y divide-[#0D0A00]/8">
                {clauses.map((c, i) => (
                  <article key={c.title} className="grid grid-cols-12 gap-4 py-10 first:pt-0">
                    <span className="col-span-2 text-[#0D0A00]/35 font-mono text-[13px] tracking-wider pt-2">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <div className="col-span-10">
                      <h3 className="text-[#0D0A00] text-[24px] md:text-[26px] font-medium tracking-[-0.02em] mb-4">
                        {c.title}
                      </h3>
                      <p className="text-[16px] text-[#0D0A00]/65 leading-[1.7] max-w-[62ch]">
                        {c.body}
                      </p>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
